import React from "react";

import { Grid } from "@material-ui/core";
import { RegisterUserSubformProps } from "./RegisterUserSubformProps";
import { UserInfoField } from "common/components";

export const RegisterUserInvestSubform = (props: RegisterUserSubformProps) => (
  <Grid container direction="column" spacing={5}>
    <Grid item xs={12} lg={12} md={12}>
      <UserInfoField id="employment" {...props} />
    </Grid>

    <Grid item xs={12} lg={12} md={12}>
      <UserInfoField id="prevEmployment" {...props} />
    </Grid>

    <Grid item xs={12} lg={12} md={12}>
      <UserInfoField
        id="highestEducation"
        className="autocomplete"
        {...props}
      />
    </Grid>

    <Grid item xs={12} lg={12} md={12}>
      <UserInfoField id="occupationGroup" className="autocomplete" {...props} />
    </Grid>
  </Grid>
);
